/**
 * Create mini cart context for custom hook
 */

import { createContext } from 'react'

const MiniCartContext = createContext({
  cart: {},
  loading: true,
  miniCartOpen: false,
  totalItems: '',
  openMiniCart: () => {},
  closeMiniCart: () => {},
  onRemoveCartLine: () => {},
})

export default MiniCartContext
